import React, { useState, useEffect } from 'react';
import { Eye, LogOut, AlertTriangle } from 'lucide-react';
import axios from 'axios';

import { BACKEND_URL } from '../config/api';

export default function ImpersonationBanner() {
  const [impersonation, setImpersonation] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkImpersonationStatus();
  }, []);

  const checkImpersonationStatus = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/auth/impersonation-status`, {
        withCredentials: true
      });
      if (response.data.is_impersonating) {
        setImpersonation(response.data);
      }
    } catch (error) {
      // Not impersonating or error - ignore
    }
  };

  const handleEndImpersonation = async () => {
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/admin/end-impersonation`, {}, {
        withCredentials: true
      });
      // Redirect to admin dashboard
      window.location.href = '/admin/dashboard';
    } catch (error) {
      console.error('Failed to end impersonation');
      setLoading(false);
    }
  };

  if (!impersonation) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-purple-600 to-purple-800 text-white py-2 px-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-white/20 rounded-full px-3 py-1">
            <Eye className="w-4 h-4" />
            <span className="text-sm font-medium">Admin viewing as user</span>
          </div>
          <div className="flex items-center gap-2 text-purple-200">
            <AlertTriangle className="w-4 h-4" />
            <span className="text-sm">
              Impersonating user • Admin: <span className="font-medium text-white">{impersonation.admin_name}</span>
            </span>
          </div>
        </div>
        <button
          onClick={handleEndImpersonation}
          disabled={loading}
          className="flex items-center gap-2 px-4 py-1.5 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium disabled:opacity-50"
          data-testid="end-impersonation-btn"
        >
          <LogOut className="w-4 h-4" />
          {loading ? 'Exiting...' : 'Exit Impersonation'}
        </button>
      </div>
    </div>
  );
}
